module.exports = __webpack_public_path__ + "src/assets/music/32d905efd1daabb677656588881b9064.mp3";